import React from 'react'
import { Paper } from '@material-ui/core'

import { CardDb } from '../redux/cardDbSlice';
import DesignUiCard from './DesignUiCard'
import { EditUiCardItemDbHashType } from '../components/EditDialog';

type EditUiCardProps = {
  cardId: string;
  card: CardDb;
  setCard: (card: CardDb) => void;
  uiItems: EditUiCardItemDbHashType;
  setUiItems: (items: EditUiCardItemDbHashType) => void;
}
const EditUiCard: React.FC<EditUiCardProps> = ({cardId, card, setCard, uiItems, setUiItems}) => {
  return (
    <Paper>
      <DesignUiCard cardId={cardId} card={card} setCard={setCard} uiItems={uiItems} setUiItems={setUiItems}/>
    </Paper> 
  );
}

export default EditUiCard;
